<div>

  <p-card>
    <div class="p-d-flex user-config">
      <img src="/assets/img/no-user.jpeg">
      <div class="p-ml-2 p-flex-grow-1 p-d-flex p-flex-column">
        <h2 class="p-m-0">{{user.displayName}}</h2>
        <small><fa-icon [icon]="['fas', 'envelope']"></fa-icon> {{user.userPrincipalName}}</small>
        <small><fa-icon [icon]="['fas', 'key']"></fa-icon> {{user.id}}</small>
      </div>
    </div>
  </p-card>

  <p-card styleClass="p-mt-4">
    <ng-template pTemplate="header">
      <div class="p-card-title p-d-flex">
        Configuración de cuenta
      </div>
    </ng-template>
    <div class="p-grid">
      <div class="p-col-12 p-field p-m-0">
        <label>Usuario de axial vinculado</label>
        <p-dropdown placeholder="Seleccione opción" [options]="users" [(ngModel)]="user.user_id" optionLabel="name" optionValue="id"></p-dropdown>
      </div>
      <div class="p-col-12 p-field p-m-0">
        <label>Permitir enviar correo con esta cuenta</label>
        <p-checkbox [binary]="true" [(ngModel)]="user.mail.allow_send"></p-checkbox>
      </div>
    </div>
  </p-card>

  <p-card styleClass="p-mt-4">
    <ng-template pTemplate="header">
      <div class="p-card-title p-d-flex">
        <div class="flex-grow-1">Sincronización de contactos</div>
        <div>
          <p-inputSwitch [(ngModel)]="user.contacts.enabled"></p-inputSwitch>
        </div>
      </div>
    </ng-template>
    <div *ngIf="user.contacts.enabled" class="p-grid">
      <div class="p-col-12 p-field p-m-0">
        <label>Modo de sincronización</label>
        <p-dropdown placeholder="Seleccione opción" [options]="contactsModes" [(ngModel)]="user.contacts.mode" optionLabel="name" optionValue="value"></p-dropdown>
      </div>
      <div class="p-col-12 p-field p-m-0">
        <label>Eliminar contactos de office 365 (al borrar en Axial)</label>
        <p-checkbox [binary]="true" [(ngModel)]="user.contacts.remote_delete"></p-checkbox>
      </div>
    </div>
    <div *ngIf="!user.contacts.enabled" class="p-grid">
      <div class="p-col-12">
        <small>Sincronización desactivada</small>
      </div>
    </div>
  </p-card>


  <p-card styleClass="p-mt-4">
    <ng-template pTemplate="header">
      <div class="p-card-title p-d-flex">
        <div class="flex-grow-1">Sincronización de correo</div>
        <div>
          <p-inputSwitch [(ngModel)]="user.mail.enabled"></p-inputSwitch>
        </div>
      </div>
    </ng-template>
    <div *ngIf="user.mail.enabled" class="p-grid">
      <div class="p-col-12 p-field p-m-0">
        <label>Modo de sincronización correo entrante</label>
        <p-dropdown placeholder="Seleccione opción" [options]="mailModes" [(ngModel)]="user.mail.mode_inbound" optionLabel="name" optionValue="value"></p-dropdown>
      </div>
      <div class="p-col-12 p-field p-m-0">
        <label>Modo de sincronización correo saliente</label>
        <p-dropdown placeholder="Seleccione opción" [options]="mailModes" [(ngModel)]="user.mail.mode_outbound" optionLabel="name" optionValue="value"></p-dropdown>
      </div>
    </div>
    <div *ngIf="!user.mail.enabled" class="p-grid">
      <div class="p-col-12">
        <small>Sincronización desactivada</small>
      </div>
    </div>
  </p-card>


  <p-card styleClass="p-mt-4">
    <ng-template pTemplate="header">
      <div class="p-card-title p-d-flex">
        <div class="flex-grow-1">Sincronización de calendario</div>
        <div>
          <p-inputSwitch [(ngModel)]="user.calendar.enabled"></p-inputSwitch>
        </div>
      </div>
    </ng-template>
    <div *ngIf="user.calendar.enabled" class="p-grid">
      <div class="p-col-12 p-field p-m-0">
        <label>Modo de sincronización</label>
        <p-dropdown placeholder="Seleccione opción" [options]="calendarModes" [(ngModel)]="user.calendar.mode" optionLabel="name" optionValue="value"></p-dropdown>
      </div>
      <div class="p-col-12 p-field p-m-0" *ngIf="user.calendar.mode=='<' || user.calendar.mode=='<=>'">
        <label>Descargar reuniones sin categorizar</label>
        <p-checkbox [binary]="true" [(ngModel)]="user.calendar.sync_all"></p-checkbox>
      </div>
    </div>
    <div *ngIf="!user.calendar.enabled" class="p-grid">
      <div class="p-col-12">
        <small>Sincronización desactivada</small>
      </div>
    </div>
  </p-card>
</div>

<div class="p-col-12 p-d-flex p-mt-4">
  <div class="flex-grow-1"></div>
  <button pButton label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary p-button-text" (click)="cancel()"></button>
  <button class="p-ml-2" style="float: right;" icon="pi pi-save" pButton type="button" label="Guardar" (click)="save()"></button>
</div>
